export const contact = {
  brandName: 'RITUALES Y ORIENTACIÓN ESPIRITUAL',
  whatsapp: '+1 5484409080',
  whatsappHref: 'https://wa.me/15484409080',
  phone: '+1 78662241959',
  phoneHref: 'tel:+178662241959',
  email: 'ritualesyhechizosdeamor7@gmail.com',
  emailHref: 'mailto:ritualesyhechizosdeamor7@gmail.com',
  address: '8707 NW 22nd Ave, Miami, FL 33147',
  addressHref:
    'https://maps.google.com/?q=8707+NW+22nd+Ave,+Miami,+FL+33147',
} as const
